import {Message} from "../Message.js";
import global from "../global.js";
const log = global.log.getLogger("f_mtac.ui.FlashMessageArea");
log.setLevel(log.levels.WARN);

let FlashMessageArea = function FlashMessageArea() {
    let interaction_end = () => {
        $("#flash_message_area").hide();
        $("body").off("click.flash_message_area.message", "#flash_message_area .message");
    };
    this.interact = function ({tx_time, sender_name, text}) {
        let $span;

        // Remove previous flash log line(s) to fix AGPOC-6753 Multiple Flash log displayed in the same popup on SITAC
        $("#flash_message_area .message-text").empty();

        // Add new flash log line(s)
        for (let line of text.split("#§#")) {
            $span = $("<span/>").text(line).append("<br>");
            $("#flash_message_area .message-text").append($span);
        }

        $("#flash_message_area span#message-sender").text(sender_name);
        $("#flash_message_area span#message-date").text(Message.date_format(tx_time));

        return new Promise((resolve) => {
            $("body").on("click.flash_message_area.message", "#flash_message_area .message", () => {
                interaction_end();
                resolve();
            });
            $("#flash_message_area").css("display", null);
        });
    };
};

export default new FlashMessageArea();
